import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  TextField,
  Box,
  Typography,
  CircularProgress,
  IconButton,
} from '@material-ui/core';
import { FieldArray } from 'react-final-form-arrays';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { useNotify } from 'react-admin';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckIcon from '@material-ui/icons/Check';
import EditIcon from '@material-ui/icons/Edit';
import InputMask from 'react-input-mask';
import ListItemText from '@material-ui/core/ListItemText';
import { apiPut } from '../../brainApi';

const useStyles = makeStyles(() => ({
  wrapperBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: 10,
    marginBottom: 10,
  },
  saveLoader: {
    width: '25px !important',
    height: '25px !important',
  },
  editIconStyle:{
    color: '#637381',
    width:16.67,
    height:16.67,
    pointer:'pointer'
  }

}));

const UnifiedCustomerAdditionalContacts = ({
  swId,
  additionalContactList,
  setAdditionalContactList,
  formatAdditionalPhoneNumberList,
}) => {
  const classes = useStyles();
  const notify = useNotify();

  const handleChange = (value, index) => {
    const contactListCopy = [...additionalContactList];
    if (!isNaN(value)) {
      contactListCopy[index].phoneNumber = value;
    }
    setAdditionalContactList(contactListCopy);
  };

  const updateAdditionalContactsList = (contactsData, index) => {
    const phoneNumberListForPayload = [];
    setAdditionalContactList(contactsData);

    if (contactsData[index]) {
      contactsData[index].loading = true;
    }
    if (contactsData.length > 0) {
      contactsData.map((item) => {
        const numberRaw = item.phoneNumber?.replace(/[^0-9]/g, '');
        if (numberRaw !== '' && numberRaw.length === 10) {
          phoneNumberListForPayload.push(numberRaw);
        }
      });
    }

    const payload = {
      additional_phone_numbers: phoneNumberListForPayload,
    };
    apiPut(`/scheduled-work/${swId}`, payload)
      .then((response) => {
        const newContactList = formatAdditionalPhoneNumberList(
          response.additional_phone_numbers,
        );
        newContactList[index].isEditing = false;
        newContactList[index].loading = false;
        notify('Contact Information Updated!');
        setAdditionalContactList(newContactList);
      })
      .catch((err) => {
        console.log(err);
        notify('Something went wrong');
      });
  };

  const handleRemoveAdditionalContact = (index) => {
    const phoneNumberListCopy = [...additionalContactList];
    phoneNumberListCopy.splice(index, 1);
    updateAdditionalContactsList(phoneNumberListCopy, index, 'remove');
    setAdditionalContactList(phoneNumberListCopy);
  };

  const handleAddNewContact = () => {
    setAdditionalContactList([
      ...additionalContactList,
      {
        isEditing: true,
        phoneNumber: '',
        loading: false,
        cancelLoading: false,
      },
    ]);
  };

  return (
    <Box mt={2} ml={2}>
      <Typography variant="subtitle2">
        Send Service Notifications to Additional Contacts
      </Typography>
      <Form
        onSubmit={() => console.log('submited')}
        mutators={{
          ...arrayMutators,
        }}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <FieldArray name="contacts">
              {({ fields }) => (
                <>
                  {additionalContactList.map((name, index) => (
                    <div key={name} className={classes.wrapperBox}>
                      <div>
                        {additionalContactList[index]?.isEditing ? (
                          <InputMask
                            mask="(999) 999-9999"
                            placeholder="Phone"
                            value={additionalContactList[index]?.phoneNumber}
                            onChange={(e) =>
                              handleChange(
                                e.target.value.replace(/[^0-9]/g, ''),
                                index,
                              )
                            }
                            disabled={!additionalContactList[index]?.isEditing}
                          >
                            {(inputProps) => <TextField {...inputProps} />}
                          </InputMask>
                        ) : (
                          <ListItemText style={{ color: '#888' }}>
                            {additionalContactList[index]?.phoneNumber}
                          </ListItemText>
                        )}
                      </div>

                      {additionalContactList[index]?.isEditing ? (
                        <>
                          <IconButton
                            color="primary"
                            disabled={
                              additionalContactList[index]?.phoneNumber
                                .length !== 10
                            }
                            onClick={() => {
                              const additionalContactArray = [
                                ...additionalContactList,
                              ];
                              updateAdditionalContactsList(
                                additionalContactArray,
                                index,
                                'save',
                              );
                              setAdditionalContactList(additionalContactArray);
                            }}
                          >
                            {additionalContactList[index].loading ? (
                              <CircularProgress
                                className={classes.saveLoader}
                              />
                            ) : (
                              <CheckIcon />
                            )}
                          </IconButton>
                        </>
                      ) : (
                        <>
                          <IconButton
                            color="primary"
                            onClick={() => {
                              const additionalContactListCopy = [
                                ...additionalContactList,
                              ];
                              additionalContactListCopy[index].isEditing = true;
                              setAdditionalContactList(
                                additionalContactListCopy,
                              );
                            }}
                          >
                            <EditIcon className={classes.editIconStyle} />
                          </IconButton>
                          <IconButton
                            color="primary"
                            onClick={() => {
                              fields.remove(index);
                              return handleRemoveAdditionalContact(index);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </>
                      )}
                    </div>
                  ))}

                  <Button
                    disabled={fields.length === 10}
                    variant="text"
                    startIcon={<AddCircleIcon />}
                    onClick={() => {
                      fields.push({ phoneNumber: '', isEditing: true });
                      return handleAddNewContact();
                    }}
                    style={{ margin: '10px 0 10px 0' }}
                  >
                    Add Mobile Phone Number
                  </Button>
                </>
              )}
            </FieldArray>
          </form>
        )}
      />
    </Box>
  );
};

export default UnifiedCustomerAdditionalContacts;
